import { Controller } from "@hotwired/stimulus"

export default class MetamaskController extends Controller {
  static targets = ["balance"]

  sweetAlert(){
    if (globalThis.ethereum === undefined) {
      return Swal.fire({
        customClass: {
          popup: 'eth-install-popup swal-popup alert-sm-bg align-items-center justify-content-center w-100',
          htmlContainer: 'text-black-paint text-white'
        },
        animation: false,
        title: "Install MetaMask",
        html: `<a class="text-white-paint text-primary fs-30" href='https://metamask.io/download' target='_blank' rel='noopener noreferrer'>Install Now</a>`,
        icon: "error",
        confirmButtonText: "OK",
      });
    } else {
      $("#metamaskPayClaim").hide();
      $("#metamaskWalletConnect").removeClass("d-none");
    }
  }

  async connectWallet() {
    if((globalThis.ethereum === undefined)){ return this.sweetAlert() }

    try {
      const accounts = await globalThis.ethereum.request({ method: 'eth_requestAccounts' })
      await this.saveWallet(accounts[0])
      
    } catch (error) {
      console.error(error)
      return Swal.fire({
        customClass: {
          popup: 'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
          htmlContainer: 'text-black-paint text-white'
        },
        animation: false,
        title: "Error",
        html: `<p>${error.message}</p>`,
        icon: 'error',
        confirmButtonText: "OK",
      });
    }
  }

  async saveWallet(address) {
    const response = await fetch('/nfts/wallet_connect', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify({ address: address })
    })
    
    if (response.ok) {
      Swal.fire({
        customClass: {
          popup: 'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
          htmlContainer: 'text-black-paint text-white'
        },
        animation: false,
        html: "Wallet successfully saved.",
        icon: "success",
        showCloseButton: true,
        buttonsStyling: false,
        showConfirmButton: false,
        timer: 2000
      })
      globalThis.location.reload();
    } else {
      const error = await response.json();
      console.error('Failed to save wallet', error);
      Swal.fire({
        customClass: {
          popup: 'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
          htmlContainer: 'text-black-paint text-white'
        },
        animation: false,
        title: "Error",
        html: `<p>${error.message || "Unable to save wallet address."}</p>`,
        icon: 'error',
        confirmButtonText: "OK",
      });
    }
  }
}
